function retornoNumeroCorrespondente(letra) {
  letra = letra.toUpperCase();
  
  if (letra === " ") return 0;
  else if (letra == "A" || letra == "J") return 1;
  else if (letra == "B" || letra == "K" || letra == "S") return 2;
  else if (letra == "C" || letra == "L" || letra == "T") return 3;
  else if (letra == "D" || letra == "M" || letra == "U") return 4;
  else if (letra == "E" || letra == "N" || letra == "V") return 5;
  else if (letra == "F" || letra == "O" || letra == "W") return 6;
  else if (letra == "G" || letra == "P" || letra == "X") return 7;
  else if (letra == "H" || letra == "Q" || letra == "Y") return 8;
  else if (letra == "I" || letra == "R" || letra == "Z") return 9;
  else return parseInt(letra);
}

/**
* Verifica se o valor é um índice cadastral válido de IPTU
*
* @param {string} iptu
*/
function validarIPTU(iptu) {
  iptu = iptu.replace(/[^\d \w]+/g, "").trim();
  if (iptu.length !== 15) return false;

  iptu = iptu.split("");
  const valores = [3, 2, 7, 6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const posicoes = [6, 10, 11];

  let soma = 0;

  for (let index = 0; index < valores.length; index++) {
    let digito = iptu[index];
    if (posicoes.includes(index)) {
      soma += retornoNumeroCorrespondente(digito) * valores[index];
    } else {
      soma += digito * valores[index];
    } 
  }
  const resto = soma % 11;
    
  let ultimoDigito = "";
  if (resto === 0) {
     ultimoDigito = "X";
  } else if (resto === 1) {
           ultimoDigito = "0";
  } else {   
      ultimoDigito = 11 - resto;
  }     
  return iptu[14] === ultimoDigito.toString();
}

module.exports = {
  validarIPTU,
}
